<div class="feedback-root">



  <!-- 📢 Güncellemeler -->
  <div *ngIf="updates.length > 0" class="updates-section">

    <!-- 📢 BAŞLIK -->
    <div class="updates-header">
      <h5>
        <i class="fa-solid fa-bullhorn"></i>
        Güncellemeler
      </h5>

      <span class="updates-sub">
        Sistem iyileştirmeleri ve yenilikler
      </span>
    </div>

    <!-- 🔽 GÜNCELLEME KARTLARI -->
    <div *ngFor="let u of updates; let i = index" class="update-wrapper">

      <button class="update-toggle" (click)="toggle(i)" [attr.aria-expanded]="openedIndex === i">
        <div class="left">
          <span class="badge badge-minor">MINOR</span>

          <span *ngIf="i === 0" class="badge badge-new">YENİ</span>

          <strong>Versiyon {{ u.version }}</strong>
          <span class="date">({{ u.date }})</span>
        </div>

        <i class="fa-solid fa-chevron-down" [class.rotate]="openedIndex === i"></i>
      </button>

      <div *ngIf="openedIndex === i" class="update-card">
        <ul>
          <li *ngFor="let item of u.items">{{ item }}</li>
        </ul>
      </div>


    </div>
  </div>





  <!-- 📝 Feedback Form -->
  <form [formGroup]="feedbackForm" (ngSubmit)="submitFeedback()" class="feedback-card">

    <h5><i class="fa-solid fa-message"></i> Geri Bildirim</h5>

    <select class="form-control mb-2" formControlName="program">
      <option value="">Konu Seç</option>
      <option *ngFor="let t of feedbackTypes" [value]="t">
        {{ t }}
      </option>
    </select>

    <input type="email" class="form-control mb-2" placeholder="E-posta" formControlName="email" />

    <textarea rows="4" class="form-control mb-2" placeholder="Sorunun / önerin" formControlName="feedback">
    </textarea>
    <input type="file" class="form-control mb-2" (change)="onFileChange($event)" />
    <div *ngIf="imageUrl" class="mb-2 text-center">
      <img [src]="imageUrl" alt="Yüklenen Görsel"
        style="max-width: 100%; max-height: 200px; border: 1px solid #ccc; border-radius: 4px;" />
    </div>

    <button class="btn btn-primary w-100" type="submit">
      <i class="fa-solid fa-paper-plane"></i>
      Gönder
    </button>

  </form>
 <div class="feedback-container">

  <!-- Header -->
  <div class="feedback-header-bar mb-3">
    <h4>📋 Geri Bildirimlerim</h4>
    <p class="sub-text">Gönderdiğiniz tüm geri bildirimleri aşağıda görebilirsiniz.</p>
  </div>

  <!-- Feedback listesi -->
  <div class="feedback-list">
    <div *ngFor="let fb of studentFeedbacks" class="feedback-card mb-3" [ngClass]="getStatusClass(fb.status)">
      <div class="feedback-card-header">
        <h5 class="program">{{ fb.program }}</h5>
        <span class="badge" [ngClass]="getBadgeClass(fb.status)">
          {{ fb.status ? 'Onaylı' : 'Beklemede' }}
        </span>
      </div>
      <p class="feedback-text">{{ fb.feedBack }}</p>
    </div>
  </div>

</div>

<!-- Modal -->
<!-- Modal -->
<div class="modal-backdrop" *ngIf="showInfoModal">
  <div class="modal-card">
    <h4>📢 Akıllı Yoklama Sistemine Geçiş</h4>
    <p>
      Sevgili öğrenciler ve öğretmenler,<br /><br />
      Artık derslere katılımınız <strong>Akıllı Yoklama Sistemi</strong> ile takip edilmektedir.
      Bu sayede:
    </p>
    <ul>
      <li>🎯 Derslere giren ve girmeyen herkes adaletli bir şekilde değerlendirilecek.</li>
      <li>📈 Eğitim kalitesi artacak; öğretmenler derse katılımınıza göre planlama yapabilecek.</li>
      <li>💻 Dijitalleşen dünyaya ayak uydurarak, katılım ve performans verileri kolayca takip edilebilecek.</li>
      <li>⚖️ Herkes için eşit hak ve şeffaf değerlendirme sağlanacak.</li>
    </ul>
    <p>
      Lütfen artık eski yoklama sistemini kullanmayın ve derslere düzenli katılım sağlayın.
    </p>
    <button class="btn btn-primary w-100" (click)="closeModal()">
      Tamam, Anladım
    </button>
  </div>
</div>



</div>
